
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection, CustomerConfiguration_$reflection } from "../../Shared/Shared.js";
import { union_type, class_type, string_type, record_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { CustomerConfigurationUpdate_$reflection } from "../../Shared/CustomerConfigurationUpdate.js";

export class State extends Record {
    constructor(CustomerConfiguration, FormState) {
        super();
        this.CustomerConfiguration = CustomerConfiguration;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Permissions.Types.State", [], State, () => [["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateCustomerConfigurationSetting", "CustomerConfigurationFetched", "CustomerConfigurationUpdated", "UpdateFailed", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Permissions.Types.Msg", [], Msg, () => [[["Item", CustomerConfigurationUpdate_$reflection()]], [["Item", CustomerConfiguration_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]]]);
}

